import { render, staticRenderFns } from "./PrivacyPolicyPopup.vue?vue&type=template&id=a401e260"
import script from "./PrivacyPolicyPopup.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports